import React from "react";
import PropTypes from 'prop-types';
import { Button, Card } from "@material-ui/core";
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import ObjectOverride from "../ObjectOverride";
import { confirmAlert } from "react-confirm-alert";
import { Types } from "components";
import { Grid } from "@mui/material";
import Typography from "@material-ui/core/Typography";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { CardActionArea } from '@mui/material';
import APPCONFIG from "../../constants/Config";

class ModuleCard extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
		this.state.key = null;
	}

	static propTypes = {
		price: PropTypes.string.isRequired,
		type: PropTypes.string,
		isDisabled: PropTypes.bool,
	};

	static defaultProps = {
		isDisabled: false,
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

	}

	//Calls Modules table
	submitModule = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Locations_Modules._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		moduleModel.object.binary_id = locationBinaryId;
		moduleModel.object.location = location;
		moduleModel.object.location_binary_id = locationBinaryId;
		moduleModel.parent = locationBinaryId + '-' + location;
		moduleModel.object.module = module;
		moduleModel.object.account = account;

		try {
			await moduleModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success(name + " has been successfully added!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	//Calls Upgrades table
	submitUpgrade = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let upgradeModel = new API.BuildClass(Types.Upgrades._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		upgradeModel.object.location = location;
		upgradeModel.object.location_binary_id = locationBinaryId;
		upgradeModel.object.upgrade = module;
		upgradeModel.object.upgrade_type = this.props.moduleType;

		try {
			await upgradeModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success(name + " has been successfully added!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}



	removeUpgrade = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let upgradeModel = new API.BuildClass(Types.Upgrades._name, 'POST_REMOVE_UPGRADE');

		// noinspection JSValidateTypes
		upgradeModel.object.location = location;
		upgradeModel.object.location_binary_id = locationBinaryId;
		upgradeModel.object.upgrade = module;
		upgradeModel.object.upgrade_type = this.props.moduleType;

		try {
			await upgradeModel.submit(null, 'POST_REMOVE_UPGRADE', true);
			API.Toast.success(name + " has been successfully removed!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	//Calls Services
	submitService = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let serviceModel = new API.BuildClass(Types.Modules_Module_Services._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		serviceModel.object.location = location;
		serviceModel.object.location_binary_id = locationBinaryId;
		serviceModel.object.upgrade = module;
		serviceModel.object.upgrade_type = this.props.moduleType;

		try {
			await serviceModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success("Support has been successfully notified!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	//Called when any module or subscription is altered.
	refreshMarketPlace() {
		this.handleToggleModal('modalModuleLearnMore')
		if(typeof this.props.handleAfterSave === 'function') {
			this.props.handleAfterSave();
		}
	}

	//Removes Location Module
	removeModule = (pkey, binary_id, module, parent, location, locationBinaryId, name) => async () => {
		confirmAlert({
			title: 'Unsubscribe',
			message: 'Are you sure you want to unsubscribe from this Module?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true})
						let moduleModel = new API.BuildClass(Types.Locations_Modules._name, API.RequestType.DELETE);
						moduleModel.object.pkey = pkey;
						moduleModel.object.binary_id = binary_id;
						moduleModel.object.location = location;
						moduleModel.object.location_binary_id = locationBinaryId;
						moduleModel.parent = binary_id + '-' + location;
						moduleModel.object.type = module;
						try {
							await moduleModel.submit(null, API.RequestType.DELETE);
							API.Toast.success(name + " has been successfully removed!", {
								position: API.Toast.POSITION.TOP_RIGHT,
								autoClose: 8000
							})
						} catch (e) {
						}
						this.refreshMarketPlace();
						this.setState({loading: false});
					}
				},
				{
					label: 'No',
					onClick: async () => {
						this.setState({loading: true})
						//Nothing
						this.setState({loading: false})
					}
				}
			]
		});
	}

	// Calls Subscriptions table
	submitSubscription = (location, location_binary_id, moduleId, account, locationSelected, name, type) => async () => {
		confirmAlert({
			title: 'Subscription',
			message: 'Are you sure you want to change your Subscription?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true});
						let moduleModel = new API.BuildClass(Types.Locations._name, API.RequestType.UPDATE);
						moduleModel.object = locationSelected;
						moduleModel.object.type = moduleId;
						try {
							await moduleModel.submit(null, API.RequestType.UPDATE, true);
							API.Toast.success("Location: " + name + " has successfully updated their subscription plan to " + type + "!", {
								position: API.Toast.POSITION.TOP_RIGHT,
								autoClose: 8000
							})
						}
						catch (e) {
						}
						this.refreshMarketPlace();
						this.setState({loading: false})
					}
				},
				{
					label: 'No',
					onClick: async () => {
						this.setState({loading: true})
						//Nothing
						this.setState({loading: false})
					}
				}
			]
		});
	}

	//Remove Account Module - Security for now
	removeAccountModule = (account, binary_id, pkey, name) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Accounts_Modules._name, API.RequestType.DELETE);

		// noinspection JSValidateTypes
		moduleModel.object.binary_id = binary_id
		moduleModel.object.account = account;
		moduleModel.object.pkey = pkey;

		try {
			await moduleModel.submit(null, API.RequestType.DELETE, true);
			API.Toast.success(name + " has been successfully removed!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	//Adds Account Module - Security for now
	submitAccountModule = ( binary_id, account, name) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Accounts_Modules._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		moduleModel.object.binary_id = binary_id
		moduleModel.object.account = account;
		moduleModel.object.module = 3;

		try {
			await moduleModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success(name + " has been successfully added!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}


	submitCSVQuote = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let serviceModel = new API.BuildClass(Types.Locations_Modules._name, 'POST_CSV_IMPORT');
		serviceModel.files = this.model.files;

		try {
			await serviceModel.submit(this, 'POST_CSV_IMPORT', true);
			API.Toast.success("Support has been successfully notified!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	handleToggleModal = (modal) => {
		if (this.props.isDisabled) {
			return;
		} else {
			this.setState({[modal]: !this.state[modal]})
		}
	}

	render(props) {
		const {loading} = this.state;
		const {
			account, binaryId, modulePkey, moduleBinaryId, module, price,
			type, borderStyle, isSubscribed,
			parent,	location, locationBinaryId,	moduleClass, locationSelected,
			pkey, name,	moduleId, showName, isDisabled, handleAfterSave, key
		} = this.props;
		const cardClass = `card ${isDisabled ? 'disabled' : ''}`;

		//the success action button on each of the cards
		let moduleCardSuccessButton;

		if(moduleClass === 'Location Cloud Module') {
			if(isSubscribed) {
				moduleCardSuccessButton = <span>
					<div><Button type={"button"} style={{marginRight: '25px'}} class="btn btn-warning" onClick={this.removeUpgrade(module, account, binaryId, parent, location, locationBinaryId, name)}> Remove an Upgrade
					</Button><Button type={"button"} class="btn btn-primary" onClick={this.submitUpgrade(module, account, binaryId, parent, location, locationBinaryId, name)}> Add Another Upgrade</Button> </div> </span>;
			} else {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={this.submitUpgrade(module, account, binaryId, parent, location, locationBinaryId, name)}>Add Upgrade</Button>;
			}
		}
		else if (module === 12 && moduleClass === 'Service') {
			moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={this.submitCSVQuote(module, account, binaryId, parent, location, locationBinaryId, name)}>Request
				a Quote</Button>;
		}
		else if (moduleClass === 'Service') {

			moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary"
			                                  onClick={this.submitService(module, account, binaryId, parent, location, locationBinaryId, name)}>Request
				a Quote</Button>;
		}

		else if (moduleClass === "") {
			if (isSubscribed) {
				moduleCardSuccessButton = null;
			}
			//TODO: make this button go to the location itself? Ask Matt
		else {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={this.submitSubscription(location, locationBinaryId, moduleId, account, locationSelected, name, type)}>Subscribe</Button>;
			}
		} else {
			if(isSubscribed) {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-danger"
				                                  onClick={moduleClass === 'Location Module' ? this.removeModule(modulePkey, moduleBinaryId, module, parent, location, locationBinaryId, name)
					                                  : this.removeAccountModule(account, binaryId, pkey, type)}>Unsubscribe</Button>;
			} else {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={moduleClass === 'Location Module' ?
					this.submitModule(module, account, binaryId, parent, location, locationBinaryId, name) : moduleClass === 'Location Cloud Module' ? this.submitUpgrade(module, account, binaryId, parent, location, locationBinaryId, name) :
						moduleClass === 'Account Module' ?
							this.submitAccountModule(binaryId, account, name) :
							this.submitSubscription(location, locationBinaryId, moduleId, account, locationSelected, name, type)}>Subscribe</Button>;
			}
		}
		return (
			/**
			 * @param {Locations_Modules_Object} subscription
			 * @param i
			 * @returns {*}
			 */
			<>
				<Card
					id="moduleCard"
					style={{borderColor: borderStyle}}
					className={cardClass}
				>
					<CardActionArea
						onClick={() => this.handleToggleModal('modalModuleLearnMore')}
						id={"cardActionArea"}
					>
						{/*Todo: Hook up module description eventually*/}
						{/*Todo: Eventually redesign the cards to look like Square App Marketplace products*/}


						{/*if Davidsons*/}
						{module === 6 && moduleClass === 'Location Module' ?
							<Grid container spacing={2}>
								<Grid item xs={12} lg={3} xl={3} style={{maxWidth: "140px"}}>
									<img src="/assets/images/Davidson_s_Logo_White-01.png" alt={"Module Image"} />
								</Grid>
								<Grid item s={12} md={6}>
									<Typography
										id={"cardName-dav"}
										variant={"h6"}
										component={"h1"}
									>{name}</Typography>
									<Grid item xs={12}>
										<p id={"description-dav"}>{type}</p>
									</Grid>
									<div className={"row"}>
										<Grid item xs={12} xl={3}>
											<p  id={"marketPlacePrice-dav"}>{price}</p>
										</Grid>
									</div>
									<Grid item xs={12}>
										<p id={"cardClassName-dav"}>{moduleClass}{isSubscribed ? <span style={{float:"right", color: borderStyle, fontWeight: "bold"}}>Currently Subscribed</span> : null}</p>
									</Grid>
								</Grid>
							</Grid>
							:

							//else it's ffl boss or other module
							<Grid container spacing={2}>
								<Grid item xs={12} xl={3} >
									<img src="/assets/images/ffllogo.png" alt={"Module Image"}/>
								</Grid>
								<Grid item s={12} md={9}>
									<Typography
										id={"cardName"}
										variant={"h6"}
										component={"h1"}
									>{name}
										{moduleClass === 'Location Cloud Module' &&	<>{isSubscribed ? <span style={{float:"right", color: borderStyle}}>Currently Have: {this.props.amountSubscribed}</span> : null}</>}
									</Typography>
									<Grid item xs={12}>
										<p id={"description"}>{type}</p>
									</Grid>
									<div className={"row"}>
										<Grid item xs={12} xl={3}>
											<p id={"marketPlacePrice"} >{price}</p>
										</Grid>
									</div>
									<Grid item xs={12}>
										<p id={"cardClassName"}>{moduleClass}{isSubscribed ? <span style={{float:"right", color: borderStyle}}>Currently Subscribed</span> : null}</p>
									</Grid>
								</Grid>
							</Grid>
						}


						<Modal
							isOpen={this.state.modalModuleLearnMore}
							toggle={() => this.handleToggleModal('modalModuleLearnMore')}
							size={"lg"}
							backdrop={true}
							style={{opacity: 1}}
						>
							<ModalHeader toggle={() => this.handleToggleModal('modalModuleLearnMore')}>
								{name} - {moduleClass}
							</ModalHeader>
							<ModalBody>
								<div className={"row"}>
									<div className={"col-md"}>
										<img />

										{type}
									</div>
								</div>
								{module === 12 && moduleClass === 'Service' && this.state.modalModuleLearnMore === true &&
									<Framework.Elements.DropZone
										property={this.model.properties.csv_import}
										value={this.state.csv_import}
										error={this.state.csv_import_error}
										update={this.handleFileChange}
										accept={[".csv"]}
										label={'Drag \'n\' drop front csv here, or click to select csv'}
										maxSize={4e+8}
								/>}
								{module === 12 && moduleClass === 'Service' && this.state.modalModuleLearnMore === true &&
									<span>
										Please follow the <a
										href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/file_download_two`}>Template
										Spreadsheet Guide</a> for how to format your spreadsheet.
									</span>
								}
								{this.state.csv_import &&
									<span>Current Image - <b>{this.state.csv_import}</b></span>
								}
							</ModalBody>
							<ModalFooter style={{justifyContent: "space-between"}}>
								<Button type={"button"} class="btn btn-secondary" onClick={() => this.handleToggleModal('modalModuleLearnMore')}>Close</Button>
								{moduleCardSuccessButton}
							</ModalFooter>
						</Modal>
					</CardActionArea>
				</Card>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</>
		);
	}
}

export default Framework.Components.withRootState(ModuleCard);
